module.exports = __webpack_public_path__ + "img/00b3371.png";